import React from "react";
import klarnaIcon from "@/public/icons/klarna_pink.svg";
import { useTemplateStore } from "@/zustand/templateStore";
import s from "@/components/Buttons/klarnaButton.module.scss";

const KlarnaExpressButton = ({ handleClick }) => {
  const { handlePaymentMethodChange } = useTemplateStore();
  return (
    <button
      className={s["klarnaButton--express"]}
      onClick={() => {
        handlePaymentMethodChange("klarna");
        handleClick();
      }}
    >
      <img src={klarnaIcon} height="24" alt="Klarna Express" />
    </button>
  );
};

export default KlarnaExpressButton;
